const text = value => Array.isArray(value) ? value.join(', ') : typeof value === 'boolean' ? value ? 'Да' : 'Нет' : String(value == null ? '' : value);
const isNote = field => field.key === 'performance_note' || field.purpose === 'ktu_comment' || /особые|характеристика/i.test(field.label || '');
const notes = part => (((part || {}).source_details || {}).characteristics || []).filter(field => isNote(field) && text(field.value).trim() !== '');
const isEmptySource = part => Boolean(part && part.source_details && part.source_details.is_empty_line === true);
const isItr = part => ((part.source_details || {}).employee_category || part.employee_category) === 'itr';
const authorLabel = field => {
    const author = field && field.author;
    return author && author.name ? `Автор: ${author.name}` : author && author.user_id ? `Автор: пользователь №${author.user_id}` : 'Автор не сохранён';
};
const datedAuthor = author => {
    if (!author || !author.name && !author.user_id) return '';
    const name = author.name || `пользователь №${author.user_id}`;
    const date = author.occurred_at && new Date(author.occurred_at);
    return name + (date && Number.isFinite(date.getTime())
        ? ` · ${date.toLocaleString('ru-RU', {timeZone: 'Europe/Minsk', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'})}` : '');
};
function ktuAuthors(part) {
    const details = part.source_details || {}, result = [];
    const ktu = details.ktu_author, evidence = details.ktu_evidence_author;
    if (part.ktu != null && part.ktu !== '') result.push(datedAuthor(ktu) ? `КТУ выставил: ${datedAuthor(ktu)}` : 'Автор КТУ не сохранён');
    if ((details.ktu_evidence || []).length && (!ktu || !evidence || !ktu.user_id || Number(ktu.user_id) !== Number(evidence.user_id))) {
        result.push(datedAuthor(evidence) ? `Основания уточнил: ${datedAuthor(evidence)}` : 'Автор оснований не сохранён');
    }
    return result;
}
function ktuAuthorEntries(part) {
    const details = part.source_details || {}, entries = [];
    const ktu = details.ktu_author, evidence = details.ktu_evidence_author;
    if (part.ktu != null && part.ktu !== '') entries.push({label: 'КТУ выставил', author: ktu || {}});
    if ((details.ktu_evidence || []).length && (!ktu || !evidence || !ktu.user_id || Number(ktu.user_id) !== Number(evidence.user_id))) entries.push({label: 'Основания уточнил', author: evidence || {}});
    return entries;
}
const tooltip = (part, fields = notes(part)) => [part.object_name || 'Объект не указан', part.timesheet_name || (part.timesheet_id ? `Табель №${part.timesheet_id}` : ''),
    ...fields.map(field => `${text(field.value)}\n${authorLabel(field)}`)].filter(Boolean).join('\n');
const sourceKey = (part, index) => part.revision_id && (part.line_id || (part.source_details || {}).line_id)
    ? `${part.revision_id}:${part.line_id || part.source_details.line_id}` : `part:${index}`;
function sources(parts) {
    const seen = new Set();
    return parts.reduce((result, part, index) => {
        if (isEmptySource(part)) return result;
        const key = sourceKey(part, index);
        if (seen.has(key)) return result;
        seen.add(key);
        const fields = notes(part);
        if (fields.length) result.push({key, fields, part, text: fields.map(field => text(field.value)).join(' · '), title: tooltip(part, fields)});
        return result;
    }, []);
}
// Keep the assessment attached to its frozen source, even when either value is missing.
function assessments(parts) {
    const seen = new Set();
    return parts.reduce((result, part, index) => {
        if (isEmptySource(part)) return result;
        const key = sourceKey(part, index);
        if (seen.has(key)) return result;
        seen.add(key);
        const fields = notes(part);
        const ktu = part.ktu == null || part.ktu === '' || !Number.isFinite(Number(part.ktu)) ? null : Number(part.ktu);
        const emptyLabel = !part.source_details ? 'Характеристика недоступна'
            : isItr(part) ? 'ИТР — характеристика необязательна' : 'Нет обязательной характеристики';
        result.push({key, part, fields, ktu, emptyLabel, missingRequired: Boolean(part.source_details && !isItr(part) && !fields.length),
            title: [ktu == null ? 'КТУ не указан' : `КТУ ${text(ktu).replace('.', ',')}`, tooltip(part, fields)].join('\n')});
        return result;
    }, []);
}
module.exports = {text, notes, isEmptySource, isItr, authorLabel, ktuAuthors, ktuAuthorEntries, tooltip, sources, assessments};
